import logger from "../../utils/logger";
import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { deleteCustomer } from "../../slices/apps/customerSlice";

const DeleteModal = ({ id, isOpen, toggle }) => {
  const dispatch = useDispatch();

  const { deleteCustomerLoading } = useSelector((state) => {
    return {
      deleteCustomerLoading: state.customer.deleteCustomerLoading,
    };
  }, shallowEqual);

  const deleteServiceRecordFunc = async () => {
    try {
      await dispatch(deleteCustomer(id)).unwrap();
      toggle();
    } catch (error) {
      logger.error("Failed:", error);
    }
  };

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="py-3 px-5">
        <div className="mt-4 text-center">
          <i className="ri-delete-bin-line display-3 text-danger"></i>
          <div className="mt-2 pt-2 fs-14 mx-4 mx-sm-5">
            <h4>Emin misiniz?</h4>
            <p className="text-muted mx-4 mb-0">
              Müşteriyi kalıcı olarak silmek istediğinize emin misiniz?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <Button
            type="button"
            color="light"
            className="btn-label w-sm"
            onClick={toggle}
          >
            <i className="ri-close-line label-icon align-middle me-2"></i>
            Kapat
          </Button>

          <Button
            type="button"
            color="danger"
            className="btn-label w-sm"
            onClick={deleteServiceRecordFunc}
            disabled={deleteCustomerLoading}
          >
            <i className="ri-delete-bin-line label-icon align-middle me-2"></i>
            {deleteCustomerLoading ? "Siliniyor..." : "Evet, sil!"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
